import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "50",
  height: "36",
  viewBox: "0 0 50 36",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#F1F1F1",
    d: "M44.333 36H5.667A5.62 5.62 0 010 30.333V5.667A5.62 5.62 0 015.667 0h38.666A5.62 5.62 0 0150 5.667v24.75C50 33.5 47.5 36 44.333 36z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#005098",
    d: "M21.98 22.84h-3.014l1.842-10.6h3.098l-1.925 10.6zm10.97-10.358c-.585-.241-1.507-.482-2.679-.482-3.014 0-5.109 1.445-5.109 3.533 0 1.525 1.508 2.409 2.68 2.89 1.173.482 1.591.883 1.591 1.285 0 .722-.92 1.043-1.842 1.043-1.172 0-1.842-.16-2.847-.561l-.419-.161-.419 2.408c.67.322 2.01.563 3.35.563 3.182 0 5.277-1.445 5.277-3.613 0-1.204-.754-2.168-2.513-2.89-1.09-.482-1.675-.804-1.675-1.286 0-.481.586-.882 1.759-.882 1.005 0 1.675.16 2.26.4l.252.161.335-2.408m7.704-.241h-2.344c-.754 0-1.256.16-1.592.883l-4.522 9.715h3.183s.502-1.284.67-1.606h3.852l.334 1.606H43l-2.345-10.598m-3.685 6.824c.252-.642 1.173-2.97 1.173-2.97s.251-.643.42-1.044l.166.883s.587 2.57.67 3.051H36.97v.08zm-20.516-6.824l-2.932 7.226-.334-1.445C12.6 16.336 10.926 14.489 9 13.525l2.68 9.314h3.182l4.773-10.598h-3.181"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#F6A500",
    d: "M10.693 12H6v.25c3.58.917 5.965 3.083 7 5.75l-1.035-5.083c-.158-.75-.715-.917-1.272-.917"
  })]
});